import { createFileRoute, redirect } from "@tanstack/react-router";
import { isRoleName } from "@vbltc/schema/permissions";
import { landingRoute } from "../features/aco-shell/landing";
import { authClient } from "../features/auth/client";
import { readSession, SessionUnavailableError } from "../features/auth/session-read";
import { mustChangePassword } from "../features/auth/password-change";

// "/" has no page of its own: anonymous users land on /login with no page to return to (J-200: through the
// guard they returned to the Playground, which production has not), so sign-in lands on "/" again. A
// practice-role user, who reads practices but not the ACO screens, lands on Screen 11 (CR-002
// CR2-053, CR-001 CRQ-033); every other signed-in user on the summary of the first ACO with data
// (CR-005 item 4, J-191; `landingPath`), or on the no-access page without one (J-209).
export const Route = createFileRoute("/")({
  beforeLoad: async () => {
    // J-210: a 429 or 5xx on get-session is "busy", never "signed out" (`session-read.ts`).
    const read = await readSession(() => authClient.getSession());
    if (read.kind === "unavailable") throw new SessionUnavailableError(read.status);
    if (read.kind === "signed-out")
      throw redirect({ to: "/login", search: { redirect: undefined, reason: undefined } });
    // J-244: before the landing page's reads, which the server refuses until the password is changed.
    if (mustChangePassword(read.session)) throw redirect({ to: "/change-password" });
    const role = read.session.user.role;
    const can = (permissions: Record<string, string[]>) =>
      isRoleName(role) && authClient.admin.checkRolePermission({ role, permissions });
    if (can({ acoPractice: ["read"] }) && !can({ acoQuality: ["read"] }))
      throw redirect({ to: "/practice", search: {} });
    throw redirect({ href: await landingRoute(can({ acoData: ["load"] })) });
  },
});
